import { ORG_PATH_PREFIX } from '@/lib/routes';
import { isAccountPath } from './TakeoverShell/takeover-paths';

/**
 * Key page transitions on the org identity for org pages (`/orgs/<slug>`)
 * and the first segment otherwise, so switching orgs re-animates while
 * navigating within one org does not.
 *
 * Account takeover is the exception among root-level surfaces: Profile,
 * Settings, and plugin user-menu pages each have a different first segment,
 * but they share one shell. Key them together as `/account` so Layout's
 * page-fade `motion.div` does not remount the shell on every option switch
 * (Configure / Labs already share a key via `/orgs/<slug>`).
 */
export function transitionKeyForPath(pathname: string, accountExtra?: ReadonlySet<string>): string {
  if (isAccountPath(pathname, accountExtra)) {
    return '/account';
  }
  const segments = pathname.split('/');
  return segments[1] === ORG_PATH_PREFIX
    ? `/${ORG_PATH_PREFIX}/${segments[2] ?? ''}`
    : '/' + (segments[1] ?? '');
}
